// extracted by mini-css-extract-plugin
export default {"page":"o1-z","cartModal":"p1-z","checkout":"q1-z","placeholder":"r1-z","account":"s1-z"};